import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MailIcon from '@material-ui/icons/Mail'

interface Props {
  space?: string
  font?: string
  children: any
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const EmailText = (props: Props) => {
  let { children, font, space, onClick } = props

  //Assing Space to Container
  const useStyles = makeStyles({
    containerSpace: {
      width: space,
    },
  })
  const classes = useStyles(props)

  //Default Font
  if (font == null) font = 'fs-10'

  return (
    <>
      <span className={`${classes.containerSpace} icon-text`} onClick={onClick}>
        <MailIcon className="indicator" />

        <span className={`${font} primary-click-text`}>{children}</span>
      </span>
    </>
  )
}

export default EmailText
